<div class="content">
    <div class="card">
        <div class="card-content">
            <div class="card-body">
                <div class="header">
                    <div class="header-logo"><img src="../../../assets//img/login_logo.png"></div>
                </div>
            </div>
            <h2 *ngIf="unsubscribed">
                {{ "text.unsubscribed" | translate }}
            </h2>
            <div style="width: 100%; margin: 50px 0px 30px; text-align: -webkit-center;" *ngIf="isLoading">
                <mat-spinner [diameter]="110"></mat-spinner>
            </div>
            <h2 *ngIf="!unsubscribed && !isLoading">
                {{ "text.no_unsubscribed" | translate }}
            </h2>
        </div>
    </div>
</div>